import type { UnitCircleWidgetConfig } from '../unit-circle.model';

export const UNIT_CIRCLE_SPECIAL_ANGLES_PRESET: UnitCircleWidgetConfig = {
  id: 'unit-circle-special-angles',
  type: 'unit-circle',
  params: {
    point: { angle: '\\pi/4', snap: true },
    specialAngles: { showAngles: true, showCoords: true },
    quadrants: { labels: true, signIndicators: true },
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -2, xEnd: 2, yStart: -2, yEnd: 2 },
      grid: { type: 'lines', visible: true },
    },
  },
};
